import { MessageCircle, Instagram } from 'lucide-react';
import { useSettings } from '../contexts/SettingsContext';

const TikTokIcon = ({ className }) => (
  <svg
    viewBox="0 0 32 32"
    fill="currentColor"
    className={className}
  >
    <path d="M16.656 1.029c1.637-0.025 3.262-0.012 4.886-0.025 0.054 2.031 0.878 3.859 2.189 5.213l-0.002-0.002c1.411 1.271 3.247 2.095 5.271 2.235l0.028 0.002v5.036c-1.912-0.048-3.71-0.489-5.331-1.247l0.082 0.034c-0.784-0.377-1.447-0.764-2.077-1.196l0.052 0.034c-0.012 3.649 0.012 7.298-0.025 10.934-0.103 1.853-0.719 3.543-1.707 4.954l0.020-0.031c-1.652 2.366-4.328 3.919-7.371 4.011l-0.014 0c-0.123 0.006-0.268 0.009-0.414 0.009-1.73 0-3.347-0.482-4.725-1.319l0.040 0.023c-2.508-1.509-4.238-4.091-4.558-7.094l-0.004-0.041c-0.025-0.625-0.037-1.25-0.012-1.862 0.49-4.779 4.494-8.476 9.361-8.476 0.547 0 1.083 0.047 1.604 0.136l-0.056-0.008c0.025 1.849-0.050 3.699-0.050 5.548-0.423-0.153-0.911-0.242-1.42-0.242-1.868 0-3.457 1.194-4.045 2.861l-0.009 0.030c-0.133 0.427-0.21 0.918-0.21 1.426 0 0.206 0.013 0.41 0.037 0.61l-0.002-0.024c0.332 2.046 2.086 3.59 4.201 3.59 0.061 0 0.121-0.001 0.181-0.004l-0.009 0c1.463-0.044 2.733-0.831 3.451-1.994l0.010-0.018c0.267-0.372 0.45-0.822 0.511-1.311l0.001-0.014c0.125-2.237 0.075-4.461 0.087-6.698 0.012-5.036-0.012-10.060 0.025-15.083z" />
  </svg>
);

export default function WhatsAppFAB() {
  const { whatsappFloatingNumber } = useSettings();

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3 items-end" data-testid="social-fabs">
      {/* Instagram FAB */}
      <a
        href="https://www.instagram.com/keiks_reposteria?igsh=MXRibXhyeGsyb2kxYg=="
        target="_blank"
        rel="noopener noreferrer"
        title="Síguenos en Instagram"
        className="bg-gradient-to-tr from-[#f9ce34] via-[#ee2a7b] to-[#6228d7] text-white rounded-full w-12 h-12 flex items-center justify-center shadow-lg hover:shadow-xl transition-all hover:-translate-y-0.5"
      >
        <Instagram className="w-6 h-6" />
      </a>

      {/* TikTok FAB */}
      <a
        href="https://www.tiktok.com/@keiksreposteria?_t=ZS-8wZfl4O9ybf&_r=1"
        target="_blank"
        rel="noopener noreferrer"
        title="Síguenos en TikTok"
        className="bg-black text-white rounded-full w-12 h-12 flex items-center justify-center shadow-lg hover:shadow-xl transition-all hover:-translate-y-0.5"
      >
        <TikTokIcon className="p-2 w-5.5 h-5.5" />
      </a>

      {/* WhatsApp FAB */}
      <a
        href={`https://api.whatsapp.com/send?phone=${whatsappFloatingNumber}`}
        target="_blank"
        rel="noopener noreferrer"
        title="Escríbenos por WhatsApp"
        className="bg-[#25D366] hover:bg-[#20bd5a] text-white rounded-full w-12 h-12 flex items-center justify-center shadow-lg hover:shadow-xl transition-all hover:-translate-y-0.5"
      >
        <MessageCircle className="w-6 h-6" />
      </a>
    </div>
  );
}
